import { ReactNode } from 'react'

export const StyledPreviewsContainer = ({
  children
}: {
  children: ReactNode
}) => {
  return <aside className='flex flex-row flex-wrap mt-4'>{children}</aside>
}
